import createPatientIdFields from "./proxy";
import repeatPrescriptionForm from "./formidable/prescription";
import unitGuide from "./formidable/unit-guide";

const removeField = (el) => {
  el.remove();
};

// classname and callback
const classRegister = {
  //sp_dobchecker: dobField,
  frm_invisible_section: removeField,
  frm_meds: repeatPrescriptionForm,
  scorelessthan20: removeField,
  score20to24: removeField,
  score25: removeField,
  nextquestions: removeField,
  medtitle: removeField,
  importantsignpost: removeField,
  scorehide: removeField,
  totalscore: removeField,
  smallinline: removeField,
  scorelessthan5: removeField,
  scoremorethan5: removeField,
};

const backLink = () => {
  const link = document.createElement("div");

  link.classList.add("nhsuk-back-link");

  link.innerHTML = `<a class="nhsuk-back-link__link frm_prev_page" href="#">
                      <svg class="nhsuk-icon nhsuk-icon__chevron-left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" height="24" width="24">
                        <path d="M8.5 12c0-.3.1-.5.3-.7l5-5c.4-.4 1-.4 1.4 0s.4 1 0 1.4L10.9 12l4.3 4.3c.4.4.4 1 0 1.4s-1 .4-1.4 0l-5-5c-.2-.2-.3-.4-.3-.7z"></path>
                      </svg>
                      Go back
                    </a>`;
  return link;
};

const button = (el) => {
  // Add back link
  if (el.classList.contains("frm_prev_page")) {
    el.remove();
    document.querySelector(".frm_fields_container").prepend(backLink());
    return;
  }
  // Main submit
  if (
    el.classList.contains("frm_button_submit") ||
    el.classList.contains("frm_final_submit")
  ) {
    el.className = "nhsuk-button";
  }
};

const fieldset = (label) => {
  const fieldset = document.createElement("fieldset");
  const legend = document.createElement("legend");

  legend.classList.add("nhsuk-fieldset__legend");
  legend.append(label);

  fieldset.classList.add("nhsuk-fieldset");
  fieldset.append(legend);

  return fieldset;
};

const checkbox = (el) => {
  el.querySelector(".frm_opt_container").classList.add("nhsuk-checkboxes");

  for (const checkbox of el.querySelectorAll(".frm_checkbox")) {
    const label = checkbox.querySelector("label");
    const input = checkbox.querySelector("input");
    checkbox.className = "nhsuk-checkboxes__item";
    input.className = "nhsuk-checkboxes__input";
    label.className = "nhsuk-label nhsuk-checkboxes__label";

    label.before(input);
  }
  const legend = el.querySelector(".frm_primary_label");

  if (legend) el.prepend(fieldset(legend));
};

const otherField = (el) => {
  // Other field wrapper
  const formGroup = Object.assign(document.createElement("div"), {
    className: "nhsuk-form-group nhsuk-u-margin-top-3",
  });
  const otherLabel = el.querySelector("label.frm_screen_reader");
  if (otherLabel) {
    formGroup.appendChild(otherLabel);
  }
  const otherInput = el.querySelector(".frm_other_input");
  otherInput.classList.add("nhsuk-input", "nhsuk-u-visually-hidden");
  otherInput.placeholder = "Please specify...";
  formGroup.appendChild(otherInput);
  // add callback
  el.append(formGroup);
  for (const input of el.querySelectorAll("input")) {
    input.addEventListener("change", (e) => {
      if (e.target.value === "Other") {
        otherInput.classList.remove("nhsuk-u-visually-hidden");
      } else {
        otherInput.classList.add("nhsuk-u-visually-hidden");
      }
    });
  }
  return;
};

const radio = (el) => {
  // Other option

  if (el.querySelector(".frm_opt_container")) {
    el.querySelector(".frm_opt_container").classList.add("nhsuk-radios");
  }

  if (el.classList.contains("horizontal_radio")) {
    //el.querySelector(".nhsuk-radios").classList.add("nhsuk-radios--inline");
  }

  for (const radio of el.querySelectorAll(".frm_radio, .frm_scale")) {
    const label = radio.querySelector("label");
    const input = radio.querySelector("input");

    radio.className = "frm_radio nhsuk-radios__item";
    input.className = "nhsuk-radios__input";
    label.className = "nhsuk-label nhsuk-radios__label";

    label.before(input);
    // If other render the text field and hide label nhsuk-u-visually-hidden
  }
  const legend = el.querySelector(".frm_primary_label");

  if (legend) el.prepend(fieldset(legend));
};

const select = (el) => {
  el.querySelector("label").classList.add("nhsuk-label");
  el.querySelector("select").classList.add("nhsuk-select");
};

const text = (el) => {
  el.querySelector("label").classList.add("nhsuk-label");
  el.querySelector("input").classList.add("nhsuk-input");
};

const textarea = (el) => {
  el.querySelector("label").classList.add("nhsuk-label");
  el.querySelector("textarea ").classList.add("nhsuk-textarea");
};

const hint = (text) => {
  const div = document.createElement("div");
  div.classList.add("nhsuk-hint");
  div.append(text);
};

// hidden verified field
const verified = () => {
  const input = document.createElement("input");
  input.setAttribute("type", "hidden");
  input.setAttribute("name", "verified");
  input.setAttribute("value", "OK");
  return input;
};

const previewAnswer = () => {
  const input = document.createElement("input");
  input.setAttribute("id", "previewAnswer");
  input.setAttribute("type", "hidden");
  input.setAttribute("name", "preview_answer");
  return input;
};

const renderForm = (test) => {
  const form = document.querySelector(".frm-show-form");

  // Remove hidden class
  form.classList.remove("nhsuk-u-visually-hidden");

  form.appendChild(verified());

  // Check for Proxy field
  createPatientIdFields();

  // Add class to form wrapper
  document.querySelector("fieldset").classList.add("nhsuk-fieldset");

  // Hide the form legend
  const formTitle = document.querySelector(".frm_screen_reader");
  if (formTitle) {
    formTitle.classList.add("nhsuk-u-visually-hidden");
  }

  // Hide the Formidable anit spam field
  const honeyTrap = document.querySelector(".frm_verify");
  if (honeyTrap) {
    honeyTrap.classList.add("nhsuk-u-visually-hidden");
    honeyTrap.previousElementSibling.classList.add("nhsuk-u-visually-hidden");
  }

  // disable sp tooltips
  const tooltip = document.querySelector(".frm_description");

  // Collect fields
  const fields = document.querySelectorAll(".frm_form_field");

  // Preview Answer
  const previewField = document.querySelector(".preview_answer");
  if (previewField) {
    previewField.appendChild(previewAnswer());
    previewField.onchange = (e) => {
      document.getElementById("previewAnswer").value = e.target.value;
    };
  }

  // Loop through input fields
  for (const element of fields) {
    // Loop through class register
    for (const registeredClass of Object.keys(classRegister)) {
      if (element.classList.contains(registeredClass)) {
        // use callback
        classRegister[registeredClass](element);
      }
    }

    const alcohols1 = element.querySelector(".alcohols1");
    if (alcohols1) {
      alcohols1.remove();
    }
    const alcohols2 = element.querySelector(".alcohols2");
    if (alcohols2) {
      alcohols2.remove();
    }

    if (
      element.classList &&
      element.classList.contains("frm_section_heading")
    ) {
      continue;
    }

    element.classList.add("nhsuk-form-group");

    const description = element.querySelector(".frm_description");

    if (description) {
      description.style.display = "block";
      description.className = "nhsuk-hint";
    }

    const fieldType = element.querySelector("input");
    if (fieldType) {
      switch (fieldType.type) {
        case "checkbox":
          checkbox(element);
          break;
        case "text":
        case "email":
        case "number":
        case "tel":
          text(element);
          break;
        case "radio":
          radio(element);
          break;
        case "button":
        case "submit":
          button(element);
          break;
        default:
        // code block
      }
    }
    // Select
    if (element.querySelector("select")) {
      select(element);
    }

    // Textarea
    if (element.querySelector("textarea")) {
      textarea(element);
    }

    const inlineStyle = element.querySelector("style");
    // Remove all inline styles
    if (inlineStyle) {
      element.querySelector("style");
      inlineStyle.remove();
    }

    //frm_other_container
    if (element.classList.contains("frm_other_container")) {
      otherField(element);
    }

    // Check for requried field
    if (
      element.classList.contains("frm_required_field") ||
      element.classList.contains("sp_patient_identification")
    ) {
      const errorCallback = (mutationList, observer) => {
        for (const list of mutationList) {
          // Error found
          if (list.addedNodes.length > 0) {
            for (const node of list.addedNodes) {
              if (node.classList.contains("frm_error")) {
                element.classList.add("nhsuk-form-group--error");
                node.classList.add(
                  "nhsuk-error-message",
                  "nhsuk-u-margin-top-2"
                );
                for (const input of element.getElementsByTagName("input")) {
                  input.classList.add("nhsuk-input--error");
                }
              }
            }
          }
          // Error removed
          if (list.removedNodes.length > 0) {
            element.classList.remove("nhsuk-form-group--error");
            for (const input of element.getElementsByTagName("input")) {
              input.classList.remove("nhsuk-input--error");
            }
          }
        }
      };
      const observer = new MutationObserver(errorCallback);
      observer.observe(element, { childList: true });
    }
  }

  // Buttons
  const buttons = document.querySelectorAll("button, .frm_prev_page");

  // Preview answer
  for (const element of buttons) {
    button(element);
  }

  // Submit buttons
  const submitButtons = document.querySelectorAll(
    ".frm_forms input[type=submit"
  );

  for (const submit of submitButtons) {
    submit.className = "nhsuk-button";
  }

  // Remove ajax loader image
  const ajaxLoader = document.getElementsByClassName("frm_ajax_loading");
  if (ajaxLoader && ajaxLoader.length > 0) {
    ajaxLoader[0].remove();
  }
};

jQuery(document).on("frmPageChanged", () => {
  renderForm();
});

jQuery(document).on("frmFormComplete", () => {
  renderForm();
});

// nhsuk-u-visually-hidden
jQuery(document).ready(() => {
  renderForm();
});
//
